// Tab "Script": script of concept plakken → AI maakt scenes, items en een shotlist.
import React, { useState } from 'react';
import { Box, CircularProgress, TextField, Typography } from '@mui/material';
import { bevestig } from '../../../utils/bevestig';
import { meldFout } from '../../../utils/apiFout';
import { analyseer, STIL } from '../breakdownApi';
import { Primair, Uitleg } from '../onderdelen';

const MAX = 60000;

export default function ScriptTab({ productie, herlaad }) {
  const [tekst, setTekst] = useState('');
  const [bezig, setBezig] = useState(false);
  const [uitkomst, setUitkomst] = useState(null);

  async function start() {
    if (!tekst.trim() || bezig) return;
    const ok = await bevestig({
      titel: 'Script laten analyseren?',
      tekst: 'De tekst gaat naar het AI-model van Full Frame. Nieuwe scenes, items en shots worden toegevoegd; wat al bestaat wordt bijgewerkt of overgeslagen. Dit kan een minuut duren.',
      knop: 'Analyseren',
    });
    if (!ok) return;
    setBezig(true);
    setUitkomst(null);
    try {
      setUitkomst(await analyseer(productie.id, tekst));
      setTekst('');
      herlaad();
    } catch (e) { meldFout(e, 'Analyse'); }
    finally { setBezig(false); }
  }

  return (
    <Box>
      <Uitleg>
        Plak een script of concept. De AI herkent scenes (met dag/nacht en locatie), cast, locaties, props, voertuigen,
        wardrobe en SFX, en stelt per scene shots voor. Opnieuw analyseren na een nieuwe versie is veilig: bestaande scenes
        worden bijgewerkt en items of shots die er al zijn worden overgeslagen.
      </Uitleg>
      <TextField fullWidth multiline minRows={12} maxRows={30} placeholder="Plak hier het script of concept…" value={tekst}
        onChange={(e) => setTekst(e.target.value)} disabled={bezig}
        helperText={tekst.length > MAX ? `Te lang (${tekst.length.toLocaleString('nl-NL')} tekens, max. 60.000) — analyseer in delen` : ' '}
        error={tekst.length > MAX} />
      {uitkomst && (
        <Box sx={{ border: '1px solid #bbf7d0', bgcolor: '#f0fdf4', borderRadius: 2, px: 1.5, py: 1, my: 1.5 }}>
          <Typography sx={{ fontSize: 13.5, color: '#14532d' }}>
            {uitkomst.scenes_added} nieuwe scenes{uitkomst.scenes_updated ? `, ${uitkomst.scenes_updated} bijgewerkt` : ''} ·{' '}
            {uitkomst.items_added} nieuwe items{uitkomst.items_skipped ? ` (${uitkomst.items_skipped} al aanwezig)` : ''} ·{' '}
            {uitkomst.shots_added} nieuwe shots{uitkomst.shots_skipped ? ` (${uitkomst.shots_skipped} al aanwezig)` : ''}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Primair onClick={start} disabled={!tekst.trim() || bezig || tekst.length > MAX}
          startIcon={bezig ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : null}>
          {bezig ? 'Bezig met analyseren…' : 'Analyseer met AI'}
        </Primair>
        {bezig && <Typography sx={{ fontSize: 12.5, color: STIL }}>Dit duurt meestal 20 tot 60 seconden.</Typography>}
      </Box>
    </Box>
  );
}
